import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { StateUser } from '../../store/modules/users/types';
import PaymentMethodForm from './PaymentMethod/PaymnentMethodForm';
import PaymentMethodView from './PaymentMethod/PaymentMethodView';
import { getPaymentMethodRequest } from '../../store/modules/billing/actions';
import { selectPaymentMethod } from '../../store/modules/billing/selectors';
import Spinner from '../../components/spinner/Spinner';

type Props = {
  user: StateUser;
};

const PaymentMethodPage = ({ user }: Props) => {
  const dispatch = useDispatch();
  const paymentMethod = useSelector(selectPaymentMethod);
  const [changeMethod, setChangeMethod] = useState(false);
  const stripeKey = process.env.REACT_APP_STRIPE_API_KEY || '';
  const stripePromise = loadStripe(stripeKey);

  /* eslint react-hooks/exhaustive-deps: 0 */
  useEffect(() => {
    if (user && user.data && !paymentMethod.data) {
      dispatch(getPaymentMethodRequest(user.data.id));
    }
  }, [dispatch, user]);

  if (paymentMethod.loading) {
    return <Spinner />;
  }

  return (
    <div>
      {!changeMethod
      && (
        <PaymentMethodView
          paymentMethod={paymentMethod.data}
          loading={paymentMethod.loading}
          changePaymentMethod={() => setChangeMethod(true)}
        />
      )}
      {changeMethod
      && (
        <Elements stripe={stripePromise}>
          {user.data && <PaymentMethodForm user={user.data} changePaymentMethod={() => setChangeMethod(false)} />}
        </Elements>
      )}
    </div>
  );
};

export default PaymentMethodPage;
